import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  inject,
} from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AdminService } from '../../admin.service';
import { Application } from '../../../models/admin-models';
import { saveAs } from '@progress/kendo-file-saver';
import { Environment } from '../../../models/environment.model';
import { EnvironmentService } from '../../../services/environment.service';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-download-unit-profiles',
  templateUrl: './download-unit-profiles.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, MatRadioModule, FormsModule, MatButtonModule],
})
export class DownloadUnitProfilesComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private envSvc = inject(EnvironmentService);

  @Output() toggleLoading = new EventEmitter();
  @Input() applications: Application[];
  private environment: Environment;
  downloadAllProfiles = {
    app: null,
    extended: false,
    status: null,
    statusClass: null,
  };

  ngOnInit(): void {
    this.environment = this.envSvc.get();
  }

  getAllProfiles(downloadAsExcel = false) {
    this.toggleLoading.emit();
    const { app, extended } = this.downloadAllProfiles;
    this.admnSrvc
      .downloadAllUnitProfiles(app, extended, downloadAsExcel)
      .subscribe({
        next: res => {
          this.toggleLoading.emit();
          let fileData;
          const firmOrgStringSplit = this.environment.apiBase
            .split(':')[1]
            .split('/');
          const firmOrgString = (
            firmOrgStringSplit[2] +
            '_' +
            firmOrgStringSplit[4]
          ).replaceAll('.', '-');
          const filename = `${firmOrgString}_${app.toUpperCase()}-Profiles.${
            downloadAsExcel ? 'xlsx' : 'zip'
          }`;
          const reader = new FileReader();
          reader.readAsDataURL(res);

          reader.onloadend = () => {
            fileData = reader.result;
            saveAs(fileData, filename);
          };
        },
        error: err => {
          this.toggleLoading.emit();
          this.downloadAllProfiles.status = err;
          this.downloadAllProfiles.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        },
      });
  }
}
